import cleanedFilename from '~/util/cleanedFilename';

export default {
  VERIFY_BUTTON: `${cleanedFilename(__filename)}-verify-button`,
  INPUT: `${cleanedFilename(__filename)}-input`,
  CONTAINER: `${cleanedFilename(__filename)}-container`,
};
